import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Typography,
  MenuItem,
  CircularProgress
} from "@mui/material";
import { authenticationService } from "src/services";
import { get, post } from "src/services/httpClient.service";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

/* =========================
   Props
========================= */
interface AddCityProps {
  handleClose: () => void;
  fetchCities: () => void;
}

const AddCity: React.FC<AddCityProps> = ({
  handleClose,
  fetchCities
}) => {
  const { vendorId } = authenticationService.getVendorFranchiseIds();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const { showSnackbar } = useSnackbar();

  /* =========================
     State
  ========================= */
  const [districts, setDistricts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    districtId: "",
    city: "",
    shortCode: "",
    isActive: true,
    zipCode:""
  });

  /* =========================
     Fetch States
  ========================= */
  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const res = await get(
          `${APIURL}/api/miscellaneous/district/vendor/${vendorId}/findAll`
        );
        setDistricts(res?.data || []);
      } catch (error) {
        console.error("Failed to fetch states", error);
        showSnackbar("Failed to load states", "error");
      }
    };

    fetchDistricts();
  }, [APIURL, vendorId, showSnackbar]);

  /* =========================
     Handlers
  ========================= */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.districtId || !form.city) {
      showSnackbar("State and City Name are required", "warning");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        id: 0,
        districtId: Number(form.districtId),
        city: form.city,
        zipCode: form.zipCode,
        shortCode: form.shortCode || null,
        isActive: form.isActive,
        vendorId
      };

      const res = await post(`${APIURL}/api/miscellaneous/city`, payload);
      console.log('addcity', res)
      if (res)
        if (res?.statusCode == "200") {
          showSnackbar(res?.message, "success");
          fetchCities();
          handleClose();
        } else {
          showSnackbar(res?.message || "something went wrong", "error");
        }

    } catch (error) {

      showSnackbar(error?.message || "something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     UI
  ========================= */
  return (
    <Box p={3}>
      <Typography variant="h6" mb={2}>
        Add City
      </Typography>

      <Grid container spacing={2}>
        {/* State Dropdown */}
        <Grid item xs={12}>
          <TextField
            select
            fullWidth
            required
            label="District"
            name="districtId"
            value={form.districtId}
            onChange={handleChange}
          >
            {districts.map(district => (
              <MenuItem key={district.id} value={district.id}>
                {district.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* City Name */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            label="City Name"
            name="city"
            value={form.city}
            onChange={handleChange}
          />
        </Grid>

        {/* Short Code */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Short Code (Optional)"
            name="shortCode"
            value={form.shortCode}
            onChange={handleChange}
          />
        </Grid>

        {/* zip Code */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="zipCode  (Optional)"
            name="zipCode"
            value={form.zipCode}
            onChange={handleChange}
          />
        </Grid>

        {/* Status */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={form.isActive}
                onChange={(e) =>
                  setForm(prev => ({
                    ...prev,
                    isActive: e.target.checked
                  }))
                }
              />
            }
            label="Is Active"
          />
        </Grid>

        {/* Actions */}
        <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={20} color="inherit" /> : null
            }
          >
            {loading ? "Saving..." : "Save"}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddCity;
